<div class="row">
  <div class="container">
    <div class="col-6">
      <h3 class="h3">Weboldalak</h3>
      <app-site-list-view [list]="sites"></app-site-list-view>
    </div>
  </div>
</div>
